import {
    ActionsTitle,
    CollectionDropdown,
    CollectionEditButtonsContainer,
    CollectionEditContainer,
    CollectionModalInputWrapper,
    DescTitle,
    ImageCardsGrid,
    Label,
    MainTitle,
    ModalContainer,
    SendImageButtonContainer,
    SendImagesButton,
    Tab
} from './styles';
import {SendProjectModalWrapper} from "./employStyles";
import {FC, useCallback, useEffect, useMemo, useState} from "react";
import {useProfile} from "@brg/auth";
import {FlexBox, useBreakpoint, useToasts} from "@brg/ui";
import {useTranslation} from "react-i18next";
import {LayoutConst, useModal} from "../../../core";
import {API, Endpoints, Lang, LangObject, Project, ProjectAPI, TLang} from "@brg/api";
import {ImageCard} from "./ImageCard";
import {Input} from "@brg/input";
import {useGetCatalogs} from "../../hooks/api/useGetCatalogs";
import {useGetSuitableCollection} from "../../hooks/api/useGetSuitableCollection";
import { AddButton } from '_deziiign/main/pages/MainTagAdminPage/styles';
import { getLangTitle } from '_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import { setTextByLang } from 'shared/pages/teams/TeamEdit';
import { LabelRedStar } from 'shared/pages/designerEditView/styles';
import { DropdownTabs } from 'shared/pages/exploreHseContextsNew/components/DropdownTabs';
import { InfoIcon } from 'shared/components/InfoIcon/InfoIcon';


enum Tabs {
    default,
    selected
}

const INITIAL_TEMP_COLLECTION = { label: 'without_collection', value: 'without_collection'}
const AVAILABLE_FILE_TYPES = ['jpeg', 'jpg', 'png'];

const isAvailableFileType = (file: File[]) => {
    if (!file) return false;
    // @ts-ignore
    const [fileType] = file[0]?.url?.split('.')?.reverse();
    return AVAILABLE_FILE_TYPES?.includes(fileType);
}

export const SendImagesModal: FC<{project: any}> = ({project}) => {
    const profile = useProfile()
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const is992 = useBreakpoint(LayoutConst.screen.m);
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
    const { t, i18n } = useTranslation();
    const { info } = useToasts();
    const modal = useModal()
    const isGalleryArtProject = project?.contexts?.includes("galllleryart");
    const [isLoading, setIsLoading] = useState(false);
    const [selected, setSelected] = useState<string[]>([]);
    const [attachments, setAttachments] = useState([]);
    const [activeTab, setActiveTab] = useState(Tabs.default);
    const { catalogs, subCollections, isLoadingCatalogs, error, refresh } = useGetCatalogs("artz", project?.author?.accountId);
    const {collection, isLoading: isCollectionLoading} = useGetSuitableCollection(project?.projectId)
    const [activeCollection, setActiveCollection] = useState<any>(null);
    const [tempCollection, setTempCollection] = useState<any>(INITIAL_TEMP_COLLECTION);
    const [projectTitle, setProjectTitle] = useState<null | TLang[]>(null);
    const [newCollectionTitle, setNewCollectionTitle] = useState(createDefaultLangObject(''))
    const [customSubCollectionsPayload, setCustomSubCollectionsPayload] = useState<{ cardCollectionId: string; name: TLang[] }[]>([]);
    const [customSubCollectionsOptions, setCustomSubCollectionsOptions] = useState<{ label: string; value: string }[] >([]);

    const filteredCatalogs = useMemo(() => isGalleryArtProject ? catalogs : catalogs?.filter((i: any) => i?.typeCollection !== "contemporary_artz"), [catalogs, isGalleryArtProject])

    const catalogsOptions = useMemo(() => {
        if (filteredCatalogs?.length === 0 || !filteredCatalogs) return [];
        return filteredCatalogs?.map((i: any) => ({label: i?.name, value: i?.cardCollectionId, thematicId: i?.typeCollection}))
    }, [filteredCatalogs])

    const collectionOptions = useMemo(() => {
        const defaultCollections = ['without_collection', 'new_collection'];
        const defaultOptions = defaultCollections.map(i => ({
          label: t(`shop.${i}`),
          value: i
        }));
        const subCollectionOptions = subCollections?.map(sub => ({
          label: sub.name,
          value: sub.cardCollectionId,
          catalogId: sub.catalogId
        })) || [];
      
        return [
          ...defaultOptions,
          ...subCollectionOptions,
          ...customSubCollectionsOptions
        ];
      }, [t, subCollections, customSubCollectionsOptions]);

    const computeTempCollection = useMemo(() => {
        const isDefaultValue = ['without_collection', 'new_collection']?.includes(tempCollection?.label)
        return isDefaultValue ? { label: t(`shop.${tempCollection?.label}`), value: tempCollection?.value} : tempCollection
    } , [tempCollection, t])

    const isNewCollectionEdit = useMemo(() => tempCollection?.value === 'new_collection' , [tempCollection])

    useEffect(() => {
        if (project?.projectId) {
            ProjectAPI.Get({ idProject: project?.projectId })
            .then((value) => value.json() as Promise<Project<'Global'>>)
            .then((r) => setProjectTitle(r?.title))
        }
    } , [project])
    
    useEffect(() => {
        if (!!projectTitle && isNewCollectionEdit) {
            setNewCollectionTitle(projectTitle)
        }
    }, [projectTitle, isNewCollectionEdit])

    useEffect(() => {

        if (!collection || activeCollection) return;
        setActiveCollection({ label: collection?.name, value: collection?.cardCollectionId, thematicId: collection?.typeCollection });

    }, [collection, activeCollection])

    // @ts-ignore
    const selectImage = useCallback((postAttachmentId) => {
        setSelected(selected?.includes(postAttachmentId) ? selected?.filter((id: any) => id !== postAttachmentId) : [...selected, postAttachmentId]);
    }, [selected])

    const currentAttachments = useMemo(() => {

        if (activeTab === Tabs.default) return attachments;
        return attachments?.filter((attachment: any) => selected?.includes(attachment?.postAttachmentId))
    }, [attachments, activeTab, selected])

    const onSubmit = () => {
        const body: any = {
          projectId: project.projectId,
          postAttachmentIds: selected,
        };
      
        API.request()
        .endpoint(Endpoints.cardsMnePw)
        .url('api/Card/AddByPosts')
        .post()
        .body(
            {
                projectId: project?.projectId, 
                PostAttachmentIds: selected, 
                CollectionId: activeCollection?.value, 
                nameCollection: newCollectionTitle,
                thematicId: activeCollection?.thematicId
            })
          .send()
          .then(res => res.json())
          .then(r => {
            modal.show('artz-legals-success', {
              thematicId: r.thematicId,
              cardId:     r.cardId
            });
          })
          .catch(err => {
            console.error(err);
            info(t('shop.error_create_cards'));
          });
      };

    const getAttachments = useCallback((posts: any) => {

        return (posts || [])?.reduce(
            (acc: any, item: any) => ([
                ...acc,
                ...(item?.attachments?.filter((item: any) => !item?.referenceId && item?.files?.length > 0 && isAvailableFileType(item?.files)) || [])
            ]), [])
    }, [])

    const onNewCategoryTitleChange = useCallback((ev: any, lang: string) => {
        if (/^(|[a-zA-Zа-яА-Я0-9][a-zA-Zа-яА-Я0-9\s]*)$/.test(ev.target.value)) {
            setNewCollectionTitle(setTextByLang(newCollectionTitle, lang, ev.target.value))
        }
    } , [newCollectionTitle])

    const onNewCollectionCreate = () => {
        const localeEntry = newCollectionTitle.find(x=>x.lang===i18n.language);
        const label = localeEntry?.name ?? newCollectionTitle[0].name;
      
        if (collectionOptions.some(opt => opt.label === label)) {
            info(t('shop.error_collection_exists', { name: label }));
            return;
        }

        if (!selected?.length) {
            info(t('shop.error_select_images'));
            return;
        }

        API.request()
          .endpoint(Endpoints.cardsMnePw)
          .url('api/Card/AddByPosts')
          .post()
          .body({
            projectId: project?.projectId, 
            PostAttachmentIds: selected, 
            CollectionId: activeCollection?.value, 
            nameCollection: newCollectionTitle, 
            thematicId: activeCollection.thematicId
          })
          .send()
          .then(r => r.json())
          .then(r => {
              modal.show('artz-legals-success', {
                thematicId: r.thematicId,
                cardId:     r.cardId
              });
          })
          .catch(err => {
              console.error(err);
              info(t('shop.error_create_cards', { collectionName: label }));
          });
    }

    const onNewCollectionCreateCancel = () => {
        setTempCollection(INITIAL_TEMP_COLLECTION);
        setNewCollectionTitle(createDefaultLangObject(''));
    }

    const NewCollectionEdit = useMemo(() => {
        if (!isNewCollectionEdit) {
            return null;
        }

        const disable = newCollectionTitle?.some((i) => i?.name === '') || !selected?.length;

        return (
            <CollectionEditContainer direction="column" gy={24} gyMobile={16}>
                <span className="label">{t('shop.new_collection_create')}</span>
                <FlexBox gx={is992 ? 24 : 1} gxMobile={isMobile ? 1 : 24} width={'100%'} gy={is992 ? 1 : 24} gyMobile={isMobile ? 16 : 1} direction={is992 ? 'row' : 'column'} directionMobile={isMobile ? 'column' : 'row'}>
                    <FlexBox gy={12} gyMobile={8} direction="column" width={isMobile ? 'calc(50% - 12px)' : '100%'} widthMobile={isMobile ? '100%' : 'calc(50% - 12px)'}>
                        <Label>
                            {t('shop.collection_name_ru')}
                            <LabelRedStar>*</LabelRedStar>
                        </Label>
                        <Input.Text 
                            value={getLangTitle(newCollectionTitle, 'ru')}
                            onChange={(ev: any) => onNewCategoryTitleChange(ev, 'ru')}
                            placeholder={t('shop.collection_input_placeholder')}
                            maxLength={75}
                        />
                        
                    </FlexBox>
                    <FlexBox gy={12} gyMobile={8}  direction="column" directionMobile='column' width={isMobile ? 'calc(50% - 12px)' : '100%'} widthMobile={isMobile ? '100%' : 'calc(50% - 12px)'}>
                        <Label>
                            {t('shop.collection_name_en')}
                            <LabelRedStar>*</LabelRedStar>
                        </Label>
                        <Input.Text 
                            value={getLangTitle(newCollectionTitle, 'en')}
                            onChange={(ev: any) => onNewCategoryTitleChange(ev, 'en')}
                            placeholder={t('shop.collection_input_placeholder')}
                            maxLength={75}
                        />
                    </FlexBox>
                </FlexBox>
               
                <CollectionEditButtonsContainer gx={24} direction="row">
                    <AddButton style={{ marginLeft: 0 }} onClick={onNewCollectionCreateCancel}>{t('shop.collection_create_cancel')}</AddButton>
                    <AddButton filled disable={disable} onClick={onNewCollectionCreate}>{t('shop.collection_create_create')}</AddButton>
                </CollectionEditButtonsContainer>
            </CollectionEditContainer>
        )
    } , [
        isNewCollectionEdit,
        newCollectionTitle,
        t, 
        isMobile,
        is992,
        onNewCollectionCreate, 
        onNewCollectionCreateCancel,
        onNewCategoryTitleChange
    ])

    const MobileTabs = useMemo(() =>  {
        return (
            <FlexBox alignMobile='center' justifyMobile='flex-start' widthMobile={'100%'}>
            <DropdownTabs
              whiteTheme={false}
              //@ts-ignore
              activeTabKey={activeTab === 0 || activeTab === 'default' ? 'default' : 'selected'}
              mobileShrink={true}
              items={
                    {
                        default: t('shop.images'),
                        selected: t('shop.selected_images_mob')
                    }
                }
                
              onChange={(tab) => {
                setActiveTab(tab === 'selected' ? Tabs.selected : Tabs.default)
              }}
            />
          </FlexBox>
        )
    }, [activeTab, t])

    useEffect(() => {

        if (!project?.projectId) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.longread)
            .url('api/post/GetMany')
            .addQuery('idUser', '2')
            .addQuery('idLongread', project?.projectId)
            .get()
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false);
                setAttachments(getAttachments(r))
            })
    }, [project?.projectId])

    if (!profile || isLoading || isLoadingCatalogs || isCollectionLoading || !activeCollection) {
        return null;
    }

    return <ModalContainer style={{overflow: is744 ? 'auto' : 'visible', padding: isMobile ? '24px 0 48px 0' : is992 ? '90px 0 48px 0' : '0', width: '100%', justifyContent: 'center'}}>
        <SendProjectModalWrapper directionMobile='column' direction='column' justify={'flex-start'} align={"center"} style={{ position: 'relative'}}>
            <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row' directionMobile='column'>
                <FlexBox direction='row' width={'100%'}>
                    <FlexBox direction='column' directionMobile='column' gy={8} gyMobile={16}  width={'100%'}>
                        <FlexBox width={'100%'} justify='space-between'>
                            <MainTitle>
                                {t('shop.choose_images')}
                            </MainTitle>

                        </FlexBox>
                        <DescTitle>
                            {t('shop.choose_images_description')}
                        </DescTitle>
                    </FlexBox>
                </FlexBox>
                {!isMobile && <FlexBox>
                    <SendImagesButton width={246} onClick={onSubmit} disabled={selected?.length === 0 || isNewCollectionEdit}>
                        {t('shop.create_cards')}
                    </SendImagesButton>
                </FlexBox>}
            </ActionsTitle>
            <FlexBox justify='space-between' directionMobile='column' direction={is992 ? 'column' : 'row'} gx={is992 ? 1 : 56} gxMobile={1} gy={is992 ? 32 : 1} gyMobile={isMobile ? 24 : 32} width={'100%'}>
                <CollectionModalInputWrapper direction='column' directionMobile={'column'} gy={is992 ? 1 : 24} gyMobile={isMobile ? 16 : 1} gx={is992 ? 24 : 1} gxMobile={isMobile ? 1 : 24}>
                    <CollectionDropdown gy={is992 ? 8 : 12} gyMobile={8}>
                        <Label style={{ display: 'flex', alignItems: 'center'}}>
                            {t('shop.category')}
                            <LabelRedStar>*</LabelRedStar>
                            <span style={{ marginLeft: 5}}><InfoIcon msg={t('tags_modal.collections')} stc/></span>
                        </Label>
                            <Input.Dropdown
                                options={catalogsOptions}
                                value={activeCollection}
                                onChange={setActiveCollection}
                            />
                    </CollectionDropdown>
                    <CollectionDropdown gy={is992 ? 8 : 12} gyMobile={8}>
                        <Label>
                        {t('shop.collection')}
                        </Label>
                            <Input.Dropdown
                                options={collectionOptions}
                                
                                value={computeTempCollection}
                                onChange={setTempCollection}
                            />
                    </CollectionDropdown>
                    {!is992 && NewCollectionEdit}
                </CollectionModalInputWrapper>
                {is992 && NewCollectionEdit}
                <FlexBox direction='column'>
                    <FlexBox justify="space-between" offsetBottom={24} offsetBottomMobile={is992 ? 16 : 24} width={'100%'}>
                        <FlexBox gx={24}>
                            <Tab onClick={() => setActiveTab(Tabs?.default)} active={activeTab === Tabs?.default}>{t('shop.images')}</Tab>
                            <Tab onClick={() => setActiveTab(Tabs?.selected)} active={activeTab === Tabs?.selected}>{t('shop.selected_images') + ` ${selected?.length || 0}`}</Tab>
                        </FlexBox>
                    </FlexBox>
                    <ImageCardsGrid>
                        {currentAttachments?.map((attachment: any) => <ImageCard
                            customClick={() => selectImage(attachment?.postAttachmentId)}
                            selected={selected?.includes(attachment?.postAttachmentId)}
                            quality={attachment?.originalImageInfo?.quality}
                            images={attachment?.files}
                            key={attachment?.postAttachmentId}
                        />)}
                    </ImageCardsGrid>
                </FlexBox>
            </FlexBox>

            {isMobile && <SendImageButtonContainer width={'100%'}>
                <SendImagesButton fullWidth onClick={onSubmit} disabled={selected?.length === 0}>
                    {t('shop.create_cards')}
                    {!!selected?.length && <span>{`(${selected?.length})`}</span>}
                </SendImagesButton>
            </SendImageButtonContainer>}
            <div/>
        </SendProjectModalWrapper>
    </ModalContainer>
}import {
    ActionsTitle,
    CollectionDropdown,
    CollectionEditButtonsContainer,
    CollectionEditContainer,
    CollectionModalInputWrapper,
    DescTitle,
    ImageCardsGrid,
    Label,
    MainTitle,
    ModalContainer,
    SendImageButtonContainer,
    SendImagesButton,
    Tab
} from './styles';
import {SendProjectModalWrapper} from "./employStyles";
import {FC, useCallback, useEffect, useMemo, useState} from "react";
import {useProfile} from "@brg/auth";
import {FlexBox, useBreakpoint, useToasts} from "@brg/ui";
import {useTranslation} from "react-i18next";
import {LayoutConst, useModal} from "../../../core";
import {API, Endpoints, Lang, LangObject, Project, ProjectAPI, TLang} from "@brg/api";
import {ImageCard} from "./ImageCard";
import {Input} from "@brg/input";
import {useGetCatalogs} from "../../hooks/api/useGetCatalogs";
import {useGetSuitableCollection} from "../../hooks/api/useGetSuitableCollection";
import { AddButton } from '_deziiign/main/pages/MainTagAdminPage/styles';
import { getLangTitle } from '_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import { setTextByLang } from 'shared/pages/teams/TeamEdit';
import { LabelRedStar } from 'shared/pages/designerEditView/styles';
import { DropdownTabs } from 'shared/pages/exploreHseContextsNew/components/DropdownTabs';
import { InfoIcon } from 'shared/components/InfoIcon/InfoIcon';


enum Tabs {
    default,
    selected
}

const INITIAL_TEMP_COLLECTION = { label: 'without_collection', value: 'without_collection'}
const AVAILABLE_FILE_TYPES = ['jpeg', 'jpg', 'png'];

const isAvailableFileType = (file: File[]) => {
    if (!file) return false;
    // @ts-ignore
    const [fileType] = file[0]?.url?.split('.')?.reverse();
    return AVAILABLE_FILE_TYPES?.includes(fileType);
}

export const SendImagesModal: FC<{project: any}> = ({project}) => {
    const profile = useProfile()
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const is992 = useBreakpoint(LayoutConst.screen.m);
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
    const { t, i18n } = useTranslation();
    const { info } = useToasts();
    const modal = useModal()
    const isGalleryArtProject = project?.contexts?.includes("galllleryart");
    const [isLoading, setIsLoading] = useState(false);
    const [selected, setSelected] = useState<string[]>([]);
    const [attachments, setAttachments] = useState([]);
    const [activeTab, setActiveTab] = useState(Tabs.default);
    const { catalogs, subCollections, isLoadingCatalogs, error, refresh } = useGetCatalogs("artz", project?.author?.accountId);
    const {collection, isLoading: isCollectionLoading} = useGetSuitableCollection(project?.projectId)
    const [activeCollection, setActiveCollection] = useState<any>(null);
    const [tempCollection, setTempCollection] = useState<any>(INITIAL_TEMP_COLLECTION);
    const [projectTitle, setProjectTitle] = useState<null | TLang[]>(null);
    const [newCollectionTitle, setNewCollectionTitle] = useState(createDefaultLangObject(''))
    const [customSubCollectionsPayload, setCustomSubCollectionsPayload] = useState<{ cardCollectionId: string; name: TLang[] }[]>([]);
    const [customSubCollectionsOptions, setCustomSubCollectionsOptions] = useState<{ label: string; value: string }[] >([]);

    const filteredCatalogs = useMemo(() => isGalleryArtProject ? catalogs : catalogs?.filter((i: any) => i?.typeCollection !== "contemporary_artz"), [catalogs, isGalleryArtProject])

    const catalogsOptions = useMemo(() => {
        if (filteredCatalogs?.length === 0 || !filteredCatalogs) return [];
        return filteredCatalogs?.map((i: any) => ({label: i?.name, value: i?.cardCollectionId, thematicId: i?.typeCollection}))
    }, [filteredCatalogs])

    const collectionOptions = useMemo(() => {
        const defaultCollections = ['without_collection', 'new_collection'];
        const defaultOptions = defaultCollections.map(i => ({
          label: t(`shop.${i}`),
          value: i
        }));
        const subCollectionOptions = subCollections?.map(sub => ({
          label: sub.name,
          value: sub.cardCollectionId,
          catalogId: sub.catalogId
        })) || [];
      
        return [
          ...defaultOptions,
          ...subCollectionOptions,
          ...customSubCollectionsOptions
        ];
      }, [t, subCollections, customSubCollectionsOptions]);

    const computeTempCollection = useMemo(() => {
        const isDefaultValue = ['without_collection', 'new_collection']?.includes(tempCollection?.label)
        return isDefaultValue ? { label: t(`shop.${tempCollection?.label}`), value: tempCollection?.value} : tempCollection
    } , [tempCollection, t])

    const isNewCollectionEdit = useMemo(() => tempCollection?.value === 'new_collection' , [tempCollection])

    useEffect(() => {
        if (project?.projectId) {
            ProjectAPI.Get({ idProject: project?.projectId })
            .then((value) => value.json() as Promise<Project<'Global'>>)
            .then((r) => setProjectTitle(r?.title))
        }
    } , [project])
    
    useEffect(() => {
        if (!!projectTitle && isNewCollectionEdit) {
            setNewCollectionTitle(projectTitle)
        }
    }, [projectTitle, isNewCollectionEdit])

    useEffect(() => {

        if (!collection || activeCollection) return;
        setActiveCollection({ label: collection?.name, value: collection?.cardCollectionId, thematicId: collection?.typeCollection });

    }, [collection, activeCollection])

    // @ts-ignore
    const selectImage = useCallback((postAttachmentId) => {
        setSelected(selected?.includes(postAttachmentId) ? selected?.filter((id: any) => id !== postAttachmentId) : [...selected, postAttachmentId]);
    }, [selected])

    const currentAttachments = useMemo(() => {

        if (activeTab === Tabs.default) return attachments;
        return attachments?.filter((attachment: any) => selected?.includes(attachment?.postAttachmentId))
    }, [attachments, activeTab, selected])

    const onSubmit = () => {
        const body: any = {
          projectId: project.projectId,
          postAttachmentIds: selected,
        };
      
        API.request()
        .endpoint(Endpoints.cardsMnePw)
        .url('api/Card/AddByPosts')
        .post()
        .body(
            {
                projectId: project?.projectId, 
                PostAttachmentIds: selected, 
                CollectionId: activeCollection?.value, 
                nameCollection: newCollectionTitle,
                thematicId: activeCollection?.thematicId
            })
          .send()
          .then(res => res.json())
          .then(r => {
            modal.show('artz-legals-success', {
              thematicId: r.thematicId,
              cardId:     r.cardId
            });
          })
          .catch(err => {
            console.error(err);
            info(t('shop.error_create_cards'));
          });
      };

    const getAttachments = useCallback((posts: any) => {

        return (posts || [])?.reduce(
            (acc: any, item: any) => ([
                ...acc,
                ...(item?.attachments?.filter((item: any) => !item?.referenceId && item?.files?.length > 0 && isAvailableFileType(item?.files)) || [])
            ]), [])
    }, [])

    const onNewCategoryTitleChange = useCallback((ev: any, lang: string) => {
        if (/^(|[a-zA-Zа-яА-Я0-9][a-zA-Zа-яА-Я0-9\s]*)$/.test(ev.target.value)) {
            setNewCollectionTitle(setTextByLang(newCollectionTitle, lang, ev.target.value))
        }
    } , [newCollectionTitle])

    const onNewCollectionCreate = () => {
        const localeEntry = newCollectionTitle.find(x=>x.lang===i18n.language);
        const label = localeEntry?.name ?? newCollectionTitle[0].name;
      
        if (collectionOptions.some(opt => opt.label === label)) {
            info(t('shop.error_collection_exists', { name: label }));
            return;
        }

        if (!selected?.length) {
            info(t('shop.error_select_images'));
            return;
        }

        API.request()
          .endpoint(Endpoints.cardsMnePw)
          .url('api/Card/AddByPosts')
          .post()
          .body({
            projectId: project?.projectId, 
            PostAttachmentIds: selected, 
            CollectionId: activeCollection?.value, 
            nameCollection: newCollectionTitle, 
            thematicId: activeCollection.thematicId
          })
          .send()
          .then(r => r.json())
          .then(r => {
              modal.show('artz-legals-success', {
                thematicId: r.thematicId,
                cardId:     r.cardId
              });
          })
          .catch(err => {
              console.error(err);
              info(t('shop.error_create_cards', { collectionName: label }));
          });
    }

    const onNewCollectionCreateCancel = () => {
        setTempCollection(INITIAL_TEMP_COLLECTION);
        setNewCollectionTitle(createDefaultLangObject(''));
    }

    const NewCollectionEdit = useMemo(() => {
        if (!isNewCollectionEdit) {
            return null;
        }

        const disable = newCollectionTitle?.some((i) => i?.name === '') || !selected?.length;

        return (
            <CollectionEditContainer direction="column" gy={24} gyMobile={16}>
                <span className="label">{t('shop.new_collection_create')}</span>
                <FlexBox gx={is992 ? 24 : 1} gxMobile={isMobile ? 1 : 24} width={'100%'} gy={is992 ? 1 : 24} gyMobile={isMobile ? 16 : 1} direction={is992 ? 'row' : 'column'} directionMobile={isMobile ? 'column' : 'row'}>
                    <FlexBox gy={12} gyMobile={8} direction="column" width={isMobile ? 'calc(50% - 12px)' : '100%'} widthMobile={isMobile ? '100%' : 'calc(50% - 12px)'}>
                        <Label>
                            {t('shop.collection_name_ru')}
                            <LabelRedStar>*</LabelRedStar>
                        </Label>
                        <Input.Text 
                            value={getLangTitle(newCollectionTitle, 'ru')}
                            onChange={(ev: any) => onNewCategoryTitleChange(ev, 'ru')}
                            placeholder={t('shop.collection_input_placeholder')}
                            maxLength={75}
                        />
                        
                    </FlexBox>
                    <FlexBox gy={12} gyMobile={8}  direction="column" directionMobile='column' width={isMobile ? 'calc(50% - 12px)' : '100%'} widthMobile={isMobile ? '100%' : 'calc(50% - 12px)'}>
                        <Label>
                            {t('shop.collection_name_en')}
                            <LabelRedStar>*</LabelRedStar>
                        </Label>
                        <Input.Text 
                            value={getLangTitle(newCollectionTitle, 'en')}
                            onChange={(ev: any) => onNewCategoryTitleChange(ev, 'en')}
                            placeholder={t('shop.collection_input_placeholder')}
                            maxLength={75}
                        />
                    </FlexBox>
                </FlexBox>
               
                <CollectionEditButtonsContainer gx={24} direction="row">
                    <AddButton style={{ marginLeft: 0 }} onClick={onNewCollectionCreateCancel}>{t('shop.collection_create_cancel')}</AddButton>
                    <AddButton filled disable={disable} onClick={onNewCollectionCreate}>{t('shop.collection_create_create')}</AddButton>
                </CollectionEditButtonsContainer>
            </CollectionEditContainer>
        )
    } , [
        isNewCollectionEdit,
        newCollectionTitle,
        t, 
        isMobile,
        is992,
        onNewCollectionCreate, 
        onNewCollectionCreateCancel,
        onNewCategoryTitleChange
    ])

    const MobileTabs = useMemo(() =>  {
        return (
            <FlexBox alignMobile='center' justifyMobile='flex-start' widthMobile={'100%'}>
            <DropdownTabs
              whiteTheme={false}
              //@ts-ignore
              activeTabKey={activeTab === 0 || activeTab === 'default' ? 'default' : 'selected'}
              mobileShrink={true}
              items={
                    {
                        default: t('shop.images'),
                        selected: t('shop.selected_images_mob')
                    }
                }
                
              onChange={(tab) => {
                setActiveTab(tab === 'selected' ? Tabs.selected : Tabs.default)
              }}
            />
          </FlexBox>
        )
    }, [activeTab, t])

    useEffect(() => {

        if (!project?.projectId) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.longread)
            .url('api/post/GetMany')
            .addQuery('idUser', '2')
            .addQuery('idLongread', project?.projectId)
            .get()
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false);
                setAttachments(getAttachments(r))
            })
    }, [project?.projectId])

    if (!profile || isLoading || isLoadingCatalogs || isCollectionLoading || !activeCollection) {
        return null;
    }

    return <ModalContainer style={{overflow: is744 ? 'auto' : 'visible', padding: isMobile ? '24px 0 48px 0' : is992 ? '90px 0 48px 0' : '0', width: '100%', justifyContent: 'center'}}>
        <SendProjectModalWrapper directionMobile='column' direction='column' justify={'flex-start'} align={"center"} style={{ position: 'relative'}}>
            <ActionsTitle justify='space-between' justifyMobile='flex-start' direction='row' directionMobile='column'>
                <FlexBox direction='row' width={'100%'}>
                    <FlexBox direction='column' directionMobile='column' gy={8} gyMobile={16}  width={'100%'}>
                        <FlexBox width={'100%'} justify='space-between'>
                            <MainTitle>
                                {t('shop.choose_images')}
                            </MainTitle>

                        </FlexBox>
                        <DescTitle>
                            {t('shop.choose_images_description')}
                        </DescTitle>
                    </FlexBox>
                </FlexBox>
                {!isMobile && <FlexBox>
                    <SendImagesButton width={246} onClick={onSubmit} disabled={selected?.length === 0 || isNewCollectionEdit}>
                        {t('shop.create_cards')}
                    </SendImagesButton>
                </FlexBox>}
            </ActionsTitle>
            <FlexBox justify='space-between' directionMobile='column' direction={is992 ? 'column' : 'row'} gx={is992 ? 1 : 56} gxMobile={1} gy={is992 ? 32 : 1} gyMobile={isMobile ? 24 : 32} width={'100%'}>
                <CollectionModalInputWrapper direction='column' directionMobile={'column'} gy={is992 ? 1 : 24} gyMobile={isMobile ? 16 : 1} gx={is992 ? 24 : 1} gxMobile={isMobile ? 1 : 24}>
                    <CollectionDropdown gy={is992 ? 8 : 12} gyMobile={8}>
                        <Label style={{ display: 'flex', alignItems: 'center'}}>
                            {t('shop.category')}
                            <LabelRedStar>*</LabelRedStar>
                            <span style={{ marginLeft: 5}}><InfoIcon msg={t('tags_modal.collections')} stc/></span>
                        </Label>
                            <Input.Dropdown
                                options={catalogsOptions}
                                value={activeCollection}
                                onChange={setActiveCollection}
                            />
                    </CollectionDropdown>
                    <CollectionDropdown gy={is992 ? 8 : 12} gyMobile={8}>
                        <Label>
                        {t('shop.collection')}
                        </Label>
                            <Input.Dropdown
                                options={collectionOptions}
                                
                                value={computeTempCollection}
                                onChange={setTempCollection}
                            />
                    </CollectionDropdown>
                    {!is992 && NewCollectionEdit}
                </CollectionModalInputWrapper>
                {is992 && NewCollectionEdit}
                <FlexBox direction='column'>
                    <FlexBox justify="space-between" offsetBottom={24} offsetBottomMobile={is992 ? 16 : 24} width={'100%'}>
                        <FlexBox gx={24}>
                            <Tab onClick={() => setActiveTab(Tabs?.default)} active={activeTab === Tabs?.default}>{t('shop.images')}</Tab>
                            <Tab onClick={() => setActiveTab(Tabs?.selected)} active={activeTab === Tabs?.selected}>{t('shop.selected_images') + ` ${selected?.length || 0}`}</Tab>
                        </FlexBox>
                    </FlexBox>
                    <ImageCardsGrid>
                        {currentAttachments?.map((attachment: any) => <ImageCard
                            customClick={() => selectImage(attachment?.postAttachmentId)}
                            selected={selected?.includes(attachment?.postAttachmentId)}
                            quality={attachment?.originalImageInfo?.quality}
                            images={attachment?.files}
                            key={attachment?.postAttachmentId}
                        />)}
                    </ImageCardsGrid>
                </FlexBox>
            </FlexBox>

            {isMobile && <SendImageButtonContainer width={'100%'}>
                <SendImagesButton fullWidth onClick={onSubmit} disabled={selected?.length === 0}>
                    {t('shop.create_cards')}
                    {!!selected?.length && <span>{`(${selected?.length})`}</span>}
                </SendImagesButton>
            </SendImageButtonContainer>}
            <div/>
        </SendProjectModalWrapper>
    </ModalContainer>
}